{
  "version": 1,
  "permissions": {
    "COMPANY_PROFILE_EDIT": { "scope": "COMPANY", "area": "Company", "label": "Edit the company profile" },
    "PEOPLE_INVITE": { "scope": "COMPANY", "area": "People", "label": "Invite colleagues" },
    "ROLES_MANAGE": { "scope": "COMPANY", "area": "People", "label": "Manage roles and who holds them" },
    "AUDIT_READ": { "scope": "COMPANY", "area": "People", "label": "Read the company's history" },
    "TEAMS_MANAGE": { "scope": "COMPANY", "area": "People", "label": "Manage teams and their jobs" },
    "DATA_MANAGE": { "scope": "COMPANY", "area": "Data", "label": "Manage data types, sets and records" },
    "DATA_SHARING_MANAGE": { "scope": "COMPANY", "area": "Data", "label": "Share the company's data" },
    "DATA_SHARING_REQUEST": { "scope": "COMPANY", "area": "Data", "label": "Ask for other companies' data" },
    "DATA_SHARING_ACCEPT": { "scope": "COMPANY", "area": "Data", "label": "Accept data other companies share" },
    "WORKFLOWS_MANAGE": { "scope": "COMPANY", "area": "Workflows", "label": "Build and publish workflows" },
    "RELATIONSHIPS_MANAGE": { "scope": "COMPANY", "area": "Relationships", "label": "Manage relationships with other companies" },
    "BILLING_MANAGE": { "scope": "COMPANY", "area": "Billing", "label": "Manage the subscription" },
    "DIRECTOR_CLAIMS_VERIFY": { "scope": "COMPANY", "area": "People", "label": "Verify director claims" },
    "PLATFORM_COMPANIES_READ": { "scope": "PLATFORM", "area": "nodeStream", "label": "Read every company" },
    "PLATFORM_TRUST_REVIEW": { "scope": "PLATFORM", "area": "nodeStream", "label": "Review trust scores" },
    "PLATFORM_WORKFLOWS_MANAGE": { "scope": "PLATFORM", "area": "nodeStream", "label": "Review the workflow library and build system workflows" },
    "PLATFORM_STAFF_MANAGE": { "scope": "PLATFORM", "area": "nodeStream", "label": "Manage nodeStream staff and teams" },
    "PLATFORM_COMPANY_FEATURES_MANAGE": { "scope": "PLATFORM", "area": "nodeStream", "label": "Turn companies' features on and off" },
    "PLATFORM_AUDIT_READ": { "scope": "PLATFORM", "area": "nodeStream", "label": "Read the platform's history" }
  },
  "features": {
    "DATA_STUDIO": { "label": "Data Studio", "permissions": ["DATA_MANAGE", "DATA_SHARING_MANAGE"] },
    "WORKFLOW_STUDIO": { "label": "Workflow Studio", "permissions": ["WORKFLOWS_MANAGE"] }
  },
  "systemRoles": {
    "DIRECTOR": {
      "name": "Director",
      "description": "A verified director of the company. Kept by verification, never by hand.",
      "nodeStreamOnly": false,
      "permissions": [
        "COMPANY_PROFILE_EDIT", "PEOPLE_INVITE", "ROLES_MANAGE", "AUDIT_READ", "TEAMS_MANAGE", "DATA_MANAGE",
        "DATA_SHARING_MANAGE", "DATA_SHARING_REQUEST", "DATA_SHARING_ACCEPT", "WORKFLOWS_MANAGE", "RELATIONSHIPS_MANAGE",
        "BILLING_MANAGE", "DIRECTOR_CLAIMS_VERIFY"
      ]
    },
    "COMPANY_ADMIN": {
      "name": "Company Admin",
      "description": "Runs the company on nodeStream.",
      "nodeStreamOnly": false,
      "permissions": [
        "COMPANY_PROFILE_EDIT", "PEOPLE_INVITE", "ROLES_MANAGE", "AUDIT_READ", "TEAMS_MANAGE", "DATA_MANAGE",
        "DATA_SHARING_MANAGE", "DATA_SHARING_REQUEST", "DATA_SHARING_ACCEPT", "WORKFLOWS_MANAGE", "RELATIONSHIPS_MANAGE",
        "BILLING_MANAGE"
      ]
    },
    "STAFF": {
      "name": "Staff",
      "description": "Everyone in the company. The company can change what Staff may do.",
      "nodeStreamOnly": false,
      "permissions": ["DATA_SHARING_REQUEST"]
    },
    "NS_ADMIN": {
      "name": "nodeStream Admin",
      "description": "Runs the nodeStream platform.",
      "nodeStreamOnly": true,
      "permissions": [
        "PLATFORM_COMPANIES_READ", "PLATFORM_TRUST_REVIEW", "PLATFORM_WORKFLOWS_MANAGE", "PLATFORM_STAFF_MANAGE",
        "PLATFORM_COMPANY_FEATURES_MANAGE", "PLATFORM_AUDIT_READ"
      ]
    },
    "NS_STAFF": {
      "name": "nodeStream Staff",
      "description": "Supports customers and reviews trust scores and workflows.",
      "nodeStreamOnly": true,
      "permissions": ["PLATFORM_COMPANIES_READ", "PLATFORM_TRUST_REVIEW", "PLATFORM_WORKFLOWS_MANAGE"]
    }
  }
}
